import React from 'react'

// The status chip + "last reported" line the Onboarding sections share. The
// API decides `installed` from the newest evidence — a ping, or the last
// install check (which can say it is gone) — so a removal a check saw shows
// here too.
export default function ReportStatus({
  installed,
  lastAt,
  activeLabel,
  idleLabel,
  detail = null,
}: {
  installed: boolean
  lastAt: string | null
  activeLabel: string
  idleLabel: string
  detail?: string | null
}) {
  const last = lastAt ? new Date(lastAt) : null
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span
        className={`text-[11px] font-bold uppercase rounded-full px-2 py-0.5 ${
          installed ? 'bg-[#E8F5E9] text-[#2E7D32]' : 'bg-tint text-accent-text'
        }`}
      >
        {installed ? activeLabel : idleLabel}
      </span>
      {last ? (
        <span className="text-[12px] text-text-2">
          Last event {last.toLocaleString()}
          {detail ? ` ${detail}` : ''}
        </span>
      ) : null}
    </div>
  )
}
